
import { Component, Vue, Prop } from 'vue-property-decorator'
import MainLayoutUser from '../components/MainLayoutUser.vue'
import MainLayoutMenu from '../components/MainLayoutMenu.vue'

@Component({
  name: 'BuildinLayoutLeft',
  components: { MainLayoutUser, MainLayoutMenu },
})
export default class MainLayoutHeader extends Vue {
  @Prop({ type: String })
  private theme!: 'light' | 'dark'

  //是否折叠
  private collapsed = false

  // 是否顶部导航固定
  @Prop({ type: Boolean })
  private fixedHeader!: boolean

  // 是否左侧菜单
  @Prop({ type: Boolean })
  private fixedMenu!: boolean

  protected get contentTop() {
    const breadHeight = this.$slots.bread ? 31 : 0
    const tabHeight = this.$slots.tab ? 52 : 0
    return this.fixedHeader ? breadHeight + tabHeight + 'px' : 0
  }
}
